"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Page = void 0;
const type_1 = require("./type");
Object.defineProperty(exports, "Page", { enumerable: true, get: function () { return type_1.Page; } });
const options_1 = __importDefault(require("./options"));
const pages = toPages(options_1.default);
exports.default = pages;
function toPages(options, parent = null) {
    const ret = [];
    options.forEach(v => {
        const item = genPage(v, parent);
        if (Array.isArray(v.children))
            item.children = toPages(v.children, item);
        ret.push(item);
    });
    return ret;
    function genPage(option, parent) {
        const sep = '/';
        const { name, title } = option;
        const path = !parent ? `${sep}${option.name}` : `${parent.path}${sep}${option.name}`;
        return {
            name,
            title,
            menu: !parent || (!parent.router),
            router: normalizeRouter(option, parent, path),
            parent,
            path
        };
        function normalizeRouter(option, parent, path) {
            let router = option.router;
            if (!router) {
                if (parent === null || parent === void 0 ? void 0 : parent.router)
                    router = true;
                else
                    return;
            }
            const normalizeRouter = Object.assign({}, router === true ? { nested: true } : router);
            const nested = !!(parent === null || parent === void 0 ? void 0 : parent.router) && normalizeRouter.nested !== false;
            return {
                nested,
                path: genPath()
            };
            function genPath() {
                const customPath = normalizeRouter.customPath || '';
                const pathSuffix = normalizeRouter.pathSuffix || '';
                if (nested) {
                    if (customPath)
                        return customPath;
                    return `${option.name}${pathSuffix}`;
                }
                else {
                    if (customPath)
                        return customPath;
                    if (parent === null || parent === void 0 ? void 0 : parent.router)
                        return `${parent.router.path}/${option.name}${pathSuffix}`;
                    return `${path}${pathSuffix}`;
                }
            }
        }
    }
}
